import React, { useRef } from 'react';
import { useSearchBox } from '../../../contexts/SearchBoxContext';
import useTypingAnimation from '../../../tools/hookTypingAnimation';
import FloatingSearchBarInput from '../../FloatingSearchBar/FloatingSearchBarInput';

const TYPING_SPEED = 150;
const PAUSE_TIME = 1000;

interface SearchBoxIAProps {
  placeholderSentences: string[];
}

const SearchBoxIA: React.FC<SearchBoxIAProps> = ({ placeholderSentences }) => {
  const [query, setQuery] = React.useState('');
  const onChange = (e: string) => setQuery(e);
  const { searchBoxPosition, setSearchBoxPosition } = useSearchBox();
  const searchBoxIARef = useRef(null);

  const updateSearchBoxIAPosition = () => {
    if (searchBoxPosition !== searchBoxIARef.current.getBoundingClientRect().bottom) {
      setSearchBoxPosition({
        bottomPosition: searchBoxIARef.current.getBoundingClientRect().bottom + window.scrollY,
      });
    }
  };

  const currentText = useTypingAnimation({ placeholderSentences, TYPING_SPEED, PAUSE_TIME, query });

  React.useEffect(() => {
    updateSearchBoxIAPosition();
  }, []);
  React.useEffect(() => {
    window.addEventListener('resize', updateSearchBoxIAPosition);
    return () => {
      window.removeEventListener('resize', updateSearchBoxIAPosition);
    };
  }, []);

  return (
    <div className="searchBoxIA" ref={searchBoxIARef}>
      <FloatingSearchBarInput
        isFocus={false}
        placeholder={currentText}
        onInputChange={onChange}
        input={query}
        isDefault={true}
      />
    </div>
  );
};

export default SearchBoxIA;
